<div class="vehicle-title">
  <div class="row vehicle">
    <div class="flex self-center pad-10">
      <div class="self-center pad-right-10" aria-hidden="true">
        <span class="icon-auto"></span>
      </div>
      <div class="self-center">
        <div class="risk-info">
          <div class="caption" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
          <div class="heading">
            {{ riskDescription }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
